import { Slot } from 'expo-router';

export default function AuthLayout(): React.ReactNode {
  return <Slot />;
}
